import { observer } from 'mobx-react-lite';
import Image from 'next/legacy/image';
import DateFormatter from '@sympla/sympla-ui/lib/components/DateFormatter';
import { SearchEvent } from 'searchEvent.d';
import { DEFAULT_IMAGE } from 'constants/index';
import * as El from './EventCard.style';

type EventCardProps = {
  hasPriority?: boolean;
  sectionPosition?: number;
  dataCreative?: string;
} & SearchEvent;

function EventCard({
  name,
  location,
  images,
  url,
  duration_type,
  start_date,
  start_date_formats,
  end_date,
  end_date_formats,
  hasPriority,
  id,
  sectionPosition,
  dataCreative,
}: EventCardProps) {
  return (
    <El.Card
      href={url}
      className="sympla-card"
      data-bannerid={`${id}`}
      data-name={`${name}`}
      data-position={`${sectionPosition}`}
      data-creative={`${dataCreative}`}
      id={`${id}`}
    >
      <Image
        src={images?.xs || DEFAULT_IMAGE}
        alt={`Banner ${name}`}
        width={249}
        height={134}
        priority={hasPriority}
      />
      <El.InfoContainer>
        <El.Date>
          <DateFormatter
            startDate={start_date_formats?.pt || ''}
            endDate={end_date_formats?.pt || ''}
            durationType={duration_type}
            rawStartDate={start_date}
            rawEndDate={end_date}
          />
        </El.Date>
        <h3>{name}</h3>
        <El.Location>{`${location?.name} - ${location?.city}, ${location?.state}`}</El.Location>
      </El.InfoContainer>
    </El.Card>
  );
}

export default observer(EventCard);
